import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { CSSEvent, CSSLocation } from "../../types/model";
import { getTimeslotSummary } from "../../utils/formatDate";
import AspectRatioImage from "../AspectRatioImage";

type PropsType = {
  event: CSSEvent;
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 33.333% 66.666%;
  background-color: var(--colour-bg-alternative);

  ${({ theme }) => `${theme.breakpoints.md} {
    width: 500px;
  }`};
`;

const Content = styled.div`
  padding: var(--space-150);
  display: flex;
  flex-direction: column;
`;

const Date = styled.p`
  font-size: var(--font-size-50);
  margin: 0;

  &:not(:last-of-type) {
    margin-bottom: var(--space-50);
  }
`;

const Title = styled.p`
  font-size: var(--font-size-200);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-height: 50px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
  font-weight: 700;
  &:not(:last-of-type) {
    margin: 0 0 var(--space-100);
  }
`;

const Location = styled.p`
  margin: 0;
  font-size: var(--font-size-50);
`;

function getLocation(location: CSSLocation) {
  if (location.type === "PHYSICAL") {
    return location.store?.storeName || "";
  } else if (location.type === "DIGITAL") {
    return "event.onlineEvent";
  } else {
    return "";
  }
}

const SmallCard = ({ event }: PropsType) => {
  const { t } = useTranslation();
  const { eventImagePath, eventDetails, timeSlots, location, timeZone } = event;
  return (
    <Wrapper>
      <AspectRatioImage src={`${eventImagePath}?f=xxs`} alt="" ratio="square" />
      <Content>
        <Date>{getTimeslotSummary(timeSlots, timeZone, t)}</Date>
        <Title>{eventDetails.eventName}</Title>
        <Location>{t(getLocation(location))}</Location>
      </Content>
    </Wrapper>
  );
};

export default SmallCard;
